import React, { FC } from 'react';
import RoundedContainer from '../../../../../../ReactSharedScripts/components/RoundedContainer';
import { Layout } from 'modules/detailPage/components/Layout';
import classes from './styles/detailPage.module.scss';
import { DetailLayoutProps } from 'modules/detailPage/components/Layout/Layout';

export type DetailPageContentProps = Pick<DetailLayoutProps, 'size'>;

export const DetailPageContent: FC<React.PropsWithChildren<DetailPageContentProps>> = ({ children, size }) => {
	return (
		<Layout
			size={size}
			dataTestId='detailPageContent'
			className={classes.detailPage__content}
		>
			<RoundedContainer>{children}</RoundedContainer>
		</Layout>
	);
};
